module.exports = __webpack_public_path__ + "img/dy.85bacbb2.png";